// eslint-disable-next-line import/prefer-default-export
export enum EditPaymentStatus {
  Disable = "Disable",
  Allow = "Allow",
}
